/**
 * User Management Helper Functions
 * Shared utilities for user filtering and searching
 */

/**
 * Filter users by search term
 * Searches across email and name fields
 *
 * @param {Array} users - Array of user objects
 * @param {string} searchTerm - Search query
 * @returns {Array} Filtered users
 */
export const filterUsersBySearch = (users, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
        return users;
    }

    const searchLower = searchTerm.toLowerCase().trim();

    return users.filter(user =>
        (user.email || '').toLowerCase().includes(searchLower) ||
        (user.name || '').toLowerCase().includes(searchLower) ||
        (user.id || '').toLowerCase().includes(searchLower)
    );
};
